import React from 'react';
import './App.css';

const serviceGroups = [
  {
    title: 'Litigation & Dispute Resolution',
    copy:
      'Relentless representation across trial courts, High Courts, the Supreme Court, and specialist tribunals with transparent updates throughout the matter.',
    items: [
      'Civil, commercial, and contractual disputes',
      'Rent, tenancy, and property matters',
      'Banking litigation and recovery suits',
      'Arbitration and mediation support',
    ],
  },
  {
    title: 'Personal & Family Matters',
    copy:
      'Discreet handling of sensitive cases with an emphasis on safeguarding family assets, dignity, and inter-generational relationships.',
    items: [
      'Protection against harassment of women at the workplace',
      'Complaints under the Protection against Harassment of Women at the Workplace Act, 2010 (Pakistan)',
      'Representation before provincial and federal ombudsman offices',
      'Workplace policy drafting, compliance reviews, and training support',
      'Appeals and constitutional petitions before High Courts in Pakistan',
      'Succession, inheritance, and probate petitions',
      'Family law (maintenance, divorce, khula, child custody, dowry recovery)',
      'Guardianship and adoption proceedings',
      'Wills, trusts, and settlement agreements',
    ],
  },
  {
    title: 'Corporate Advisory & Documentation',
    copy:
      'Hands-on legal support for boards, founders, and international partners working in Pakistan under evolving regulatory landscapes.',
    items: [
      'Contract drafting, vetting, and negotiations',
      'Regulatory compliance and licensing',
      'Policy development, implementation, and monitoring',
      'Retainer-based general counsel services',
    ],
  },
  {
    title: 'Consumer Protection & Redressal',
    copy:
      'Strategic representation for consumers and businesses under Pakistan’s consumer protection laws to secure fair remedies and accountability.',
    items: [
      'Complaints and claims under provincial Consumer Protection Acts in Pakistan',
      'Recovery, replacement, and refund claims for defective goods or deficient services',
      'Unfair trade practices, overcharging, and misleading advertising disputes',
      'Representation before Consumer Courts and follow-through on enforcement',
    ],
  },
];

const secondaryPracticeAreas = ['Succession, Probate & Inheritance', 'Banking & Rent Cases', 'Contracts & Compliance'];

const consultingHighlights = [
  'Risk assessments and legal audits for manufacturing units, logistics operators, and retailers.',
  'Representation for overseas Pakistanis managing assets, inheritance, or disputes domestically.',
  'Training and knowledge sessions for in-house teams to strengthen compliance culture.',
];

function Services() {
  return (
    <main className="services">
      <section className="section-head">
        <p className="eyebrow">Services</p>
        <h2>Every engagement starts with clarity, structure, and measurable outcomes.</h2>
        <p>
          The firm offers bundled and bespoke plans to match urgent litigation, discreet personal matters, and corporate
          retainers. Select a track below or reach out to craft a path custom to your needs.
        </p>
      </section>

      <section className="service-groups">
        {serviceGroups.map(({ title, copy, items }) => (
          <article key={title} className="panel">
            <h3>{title}</h3>
            <p>{copy}</p>
            <ul>
              {items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </article>
        ))}
      </section>
      <section className="practice-bubbles">
        <p className="eyebrow" style={{ width: '100%', textAlign: 'center', marginBottom: 4 }}>Also covered</p>
        {secondaryPracticeAreas.map((label) => (
          <span key={label} className="practice-bubble">
            {label}
          </span>
        ))}
      </section>

      <section className="consulting">
        <div>
          <p className="eyebrow">Consulting edge</p>
          <h2>Strategic guidance beyond the courtroom.</h2>
          {consultingHighlights.map((item) => (
            <p key={item}>{item}</p>
          ))}
        </div>
      </section>
    </main>
  );
}

export default Services;
